import axios from 'axios';

export function Config(){
		
		// PROJETO LOCAL
		//   return {
		// 		  host : axios.defaults.baseURL ='http://127.0.0.1:8000',
		// 		  ip   : 'http://localhost:3000',
		// 	      raiz : '/gamifica'
		// 	     }
		
		// PROJETO LOCAL	
		// return {
		// 		   host : axios.defaults.baseURL ='http://10.201.40.35:8000/',
		// 		   ip   : 'http://10.201.40.35:3000',
		// 		   raiz : '/gamifica'
		// 	       }
		
		//PROJETO SENAI
		return {
		            host : axios.defaults.baseURL ='http://ead.fieb.org.br/sistemas/api/public/',
				    ip   : 'http://ead.fieb.org.br/gamifica',
					raiz : '/gamifica'
				}

		//PROJETO PORTUGAL		
		// return {
		//         	host : axios.defaults.baseURL ='http://ead.fieb.org.br/sistemas/pt/api-gamifica/public/',
		// 			ip   : 'http://ead.fieb.org.br/gamifica-pt',
		// 			raiz : '/gamifica-pt'
        //         }
}



export function jwtToken(token){

	if (token) {
     	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
	}else{

  		delete axios.defaults.headers.common['Authorization'];
	}
}






// WEBPACK FOOTER //
// ./src/actions/configActions.js